import { useTranslation } from 'react-i18next';

/**
 * Custom hook for framework translations
 * This hook provides access to framework-specific translations using the 'framework' namespace
 * @returns {Object} Translation object with t function for framework translations
 */
const useFrameworkTranslation = () => useTranslation('framework');

export default useFrameworkTranslation;
